import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "prevBtn", "nextBtn", "counter", "dot"]

  connect() {
    this.index = 0
    this.total = this.slideTargets.length
    this._render()

    // Keyboard navigation
    this._onKeydown = (e) => {
      if (e.key === "ArrowRight") this.next()
      if (e.key === "ArrowLeft")  this.prev()
    }
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
  }

  next() { this._go(this.index + 1) }
  prev() { this._go(this.index - 1) }

  goTo(e) { this._go(parseInt(e.currentTarget.dataset.slidesIndex)) }

  _go(i) {
    if (i < 0 || i >= this.total) return
    this.index = i
    this._render()
  }

  _render() {
    this.slideTargets.forEach((slide, i) => {
      slide.classList.toggle("hidden", i !== this.index)
    })

    this.dotTargets.forEach((dot, i) => {
      dot.classList.toggle("bg-emerald-600", i === this.index)
      dot.classList.toggle("bg-gray-200",   i !== this.index)
    })

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${this.index + 1} / ${this.total}`
    }

    if (this.hasPrevBtnTarget) {
      this.prevBtnTarget.disabled = this.index === 0
      this.prevBtnTarget.classList.toggle("opacity-30 pointer-events-none", this.index === 0)
    }
    if (this.hasNextBtnTarget) {
      this.nextBtnTarget.classList.toggle("hidden", this.index === this.total - 1)
    }
  }
}
